const session_expired = {
    title: 'Phiên đã hết hạn',
    subtitle: 'Phiên của bạn có thể đã hết hạn và bạn đã bị ngắt kết nối. Nhấn nút bên dưới để đăng nhập lại vào bảng quản trị.',
    button: 'Đăng nhập lại',
};
export default Object.freeze(session_expired);
